<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { mapGetters,mapActions } from 'vuex';
export default {
  name: "App",
  data() {
    return {
      audioURL: process.env.BASE_API,
    };
  },
  methods:{
    ...mapActions([
      'getAudioTag',
      'setComeFrom'
    ]),
  },
  computed: {
    ...mapGetters([
      'musicUrl',
      'isComeFromShare'
    ]),
  },
  mounted() {
    this.getAudioTag(this.$refs.audio)
    //  window.addEventListener('popstate', () => {
    //    if (this.isComeFromShare) {


    //    }
    //    console.log(this.$route.path)
    //    console.log(this.$route.query)
    //  }, false)
  },
  created() {
    if (this.$route.query.detailname) {
      this.setComeFrom(true)
    }
  }
};
</script>

<style>
@import "../static/reset.css";
#app {
  width: 100%;
  height: 100%;
  background: white;
}
.mint-indicator-wrapper{
  font-size: 40px;
  z-index: 100;
}
html,body{
    width: 100%;
    height: 100%;
}
.voice_footer{
    width:100%;
    height:30px;
    position:fixed;
    bottom:0;
    z-index:101;
    font-size:13px;
    text-align: center;
    line-height:30px;
    color:#a0a0a0;
    background:rgba(249,249,249,1);
  }
</style>



// WEBPACK FOOTER //
// src/App.vue